module.exports = __webpack_public_path__ + "static/media/dragonchain-foundation.6faa1019.svg";